// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e33bf14a","239":"30cfc710","455":"65343d4b"}[chunkId] + ".chunk.js";
};